import React, { useEffect } from "react";

import { Input } from "antd";

import StyledTooltip from "../../../Common/UIComponents/StyledTooltip";
import { CHAR_LIMITS } from "../Constant";
import MaxCharacterCount from "../ReusableComponents/MaxCharacterCount";

import { ReactComponent as ExclamationIcon } from "../../../../assets/images/sample-submission/exclamationIcon.svg";
import { ReactComponent as MaximizeIcon } from "../../../../assets/images/sample-submission/maximize_icon.svg";
import { ReactComponent as MinimizeIcon } from "../../../../assets/images/sample-submission/minimize_icon.svg";

import "./SampleID.css";

export default function SampleID({
  sampleID,
  disableAddSample,
  sampleIDGenerationError,
  submissionEditingSample,
  onLoad,
  sampleNumber,
  isMaximized,
  onToggleMaximize,
  showMaximize,
}) {
  useEffect(() => {
    onLoad();
  }, [onLoad]);
  const invalidSampleIDLength = sampleID.length > CHAR_LIMITS.sample_id;
  const showError = invalidSampleIDLength || sampleIDGenerationError;

  let message = "Sample ID is auto-generated by user inputted data";
  if (sampleIDGenerationError) {
    message = "Failed to generate Sample ID";
  } else if (invalidSampleIDLength) {
    message = "Sample ID is too long, please fix your inputs";
  }

  return (
    <div className="new-submission-pages-card-sample-id">
      {disableAddSample && (<div className="SampleSubmissionForm__DisableAddSample" />)}
      <div className="SampleID__TitleRow">
        {Number.isFinite(sampleNumber) && (
          <span className="SampleID__Number">{`${sampleNumber}.`}</span>
        )}
        <label htmlFor="new-submission-sample-id">Sample ID</label>
      </div>
      <StyledTooltip
        title={message}
        placement="top"
      >
        <ExclamationIcon className={`SampleID__ErrorIcon${showError ? "--red" : ""}`} width={14} height={14} />
      </StyledTooltip>
      <div className={`SampleID__InputDiv  ${submissionEditingSample ? "new-submission-pages-card-sample-id-edit" : ""}`}>
        <Input
          id="new-submission-sample-id"
          value={sampleID}
          readOnly
          status={showError ? "error" : undefined}
          className="SampleID__Input"
        />
        {CHAR_LIMITS.sample_id && (
        <MaxCharacterCount
          charCount={sampleID.length}
          charLimit={CHAR_LIMITS.sample_id}
        />
        )}
      </div>
      {showMaximize && onToggleMaximize && (
        <StyledTooltip title={isMaximized ? "Minimize" : "Maximize"}>
          <button
            className="SampleID__MaximizeButton"
            type="button"
            onClick={onToggleMaximize}
          >
            {isMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
          </button>
        </StyledTooltip>
      )}
    </div>
  );
}
